import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const dpiHandlingLocaleModule: LocaleModule = {
  name: "dpiHandling",
  messages: { en: en, it: it },
};
